// src/hooks/usePlanLimits.js
import { useState, useEffect } from 'react';
import axiosConfig from '../api/axiosConfig';

export const usePlanLimits = () => {
    const [limits, setLimits] = useState(null);
    const [usage, setUsage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetch = async () => {
            try {
                const [limitsRes, statsRes] = await Promise.all([
                    axiosConfig.get('/subscriptions/current'),
                    axiosConfig.get('/organizations/stats'),
                ]);
                setLimits(limitsRes.data?.data?.limits || null);
                setUsage(statsRes.data?.data || null);
            } catch {
                // non bloccante
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, []);

    const format = (used, max) => {
        if (max === -1 || max === null || max === undefined) return `${used} / ∞`;
        return `${used} / ${max}`;
    };

    return {
        loading,
        expenses: { used: usage?.expensesCount ?? 0, max: limits?.maxExpenses ?? null, label: format(usage?.expensesCount ?? 0, limits?.maxExpenses) },
        projects: { used: usage?.projectsCount ?? 0, max: limits?.maxProjects ?? null, label: format(usage?.projectsCount ?? 0, limits?.maxProjects) },
        users: { used: usage?.usersCount ?? 0, max: limits?.maxUsers ?? null, label: format(usage?.usersCount ?? 0, limits?.maxUsers) },
        storage: { used: usage?.storageUsedMb ?? 0, max: limits?.maxStorageMb ?? null, label: format(usage?.storageUsedMb ?? 0, limits?.maxStorageMb) },
    };
};